// Usado en relacion con entidad Compra
export const TipoTransaccion = {
  Presupuesto: 1,
  NotaEvolucion: 2,
  VentaMostrador: 3,
  Todos: 0
}

// Tipo de cortes de caja del dia
export const TipoReporteCorteCaja = {
  PorCajero: 'cortePorCajero',
  PorFormaPago: 'cortePorFormaPago',
  PorServicio: 'cortePorServicio',
  PorDentista: 'cortePorDentista'
}